import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import Input from "../../../../Components/Input/Input";
import { FiSearch } from "react-icons/fi";
import AutoCompleteSearch from "../../../../Components/AutoCompleteSearch/AutoCompleteSearch";
import { getAllFilteredEmployees } from "../../../../Redux/Actions/HR";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../../Components/Header/Header";
import MetaData from "../../../../Components/MetaData";
import {
  getAllLoanRequests,
  indivisualLoanRequestDeleted,
} from "../../../../Redux/Actions/LoanRequests";
import MuiDataTable from "../../../../Components/MUIDataTable/MUIDataTable";
import Loader from "../../../../Utils/Loader";
import { Avatar, Typography } from "@mui/material";
import { FaEye } from "react-icons/fa";
import { BsTrashFill } from "react-icons/bs";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { errorNotify, successNotify } from "../../../../Utils/toast";
import { useStyle } from "../Attendance/attendance-styles";
import { BiSearch, BiReset } from "react-icons/bi";
import DeleteConfirmModal from "../../../../Components/DeleteConfirmModal/DeleteConfirmModal";
import {
  formatAmountLeftTableDisplay,
  formatAmountPaidTableDisplay,
  formatRsTable,
  getLoanRowStatus,
} from "./loanRequestUtils";

const formatRs = formatRsTable;

const centeredColumnOptions = {
  setCellProps: () => ({
    style: {
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
    },
  }),
  setCellHeaderProps: () => ({ style: { textAlign: "center" } }),
};

const LoanRequests = () => {
  const [id, setId] = useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(5);
  const classes = useStyle();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchName, setSearchName] = useState("");
  const [pageSearch, setPageSearch] = useState(false);
  const [show, setShow] = useState(false);
  const [loanId, setLoanId] = useState("");
  const { employees: filtered } = useSelector(
    (state) => state.filteredEmployees,
  );
  const { loading, loans, loanCount } = useSelector(
    (state) => state.getLoanRequests,
  );
  const {
    deleted,
    loading: deleteLoading,
    error: deleteError,
  } = useSelector((state) => state.deleteLoanRequest);

  useEffect(() => {
    dispatch(getAllFilteredEmployees());
    const saved = window.sessionStorage.getItem("saveLoanUser");
    let employeeId = "";
    if (saved) {
      const parsed = JSON.parse(saved);
      setSearchName(parsed.full_name);
      setId(parsed._id);
      employeeId = parsed._id;
    }
    dispatch(getAllLoanRequests(page, size, employeeId));
  }, []);

  useEffect(() => {
    dispatch(getAllLoanRequests(page, size, id || ""));
  }, [page, size, pageSearch]);

  useEffect(() => {
    if (deleted?.success) {
      successNotify(deleted?.message);
      setShow(false);
      dispatch({ type: "INDIVISUAL_LOAN_REQUEST_DELETE_RESET" });
      dispatch(getAllLoanRequests(page, size, id || ""));
    }
    if (deleteError) {
      errorNotify(deleteError);
      dispatch({ type: "CLEAR_ERRORS" });
    }
  }, [deleted?.success, deleteError]);

  const handleLoanDeleteClick = (deleteId) => {
    setLoanId(deleteId);
    setShow(true);
  };


  const columns = [
    { name: "_id", options: { display: false } },
    {
      name: "requested_by",
      label: "Employee",
      options: {
        customBodyRender: (value) => (
          <EmployeeRow value={value} navigate={navigate} />
        ),
      },
    },
    {
      name: "applied_date",
      label: "Applied Date",
      options: {
        ...centeredColumnOptions,
        customBodyRender: (value) => (
          <Typography className="fs-12" sx={{ width: "100%", textAlign: "center" }}>
            {value ? moment(value).format("DD-MM-YYYY") : "-"}
          </Typography>
        ),
      },
    },
    {
      name: "amount",
      label: "Amount (Rs)",
      options: {
        ...centeredColumnOptions,
        customBodyRender: (value) => (
          <Typography className="fs-12" sx={{ width: "100%", textAlign: "center" }}>
            {formatRs(value)}
          </Typography>
        ),
      },
    },
    {
      name: "amount_paid",
      label: "Amount Paid (Rs)",
      options: {
        ...centeredColumnOptions,
        customBodyRender: (value, tableMeta) => (
          <Typography
            className="fs-12"
            sx={{ width: "100%", textAlign: "center", color: "success.main" }}
          >
            {formatAmountPaidTableDisplay(value, getLoanRowStatus(tableMeta))}
          </Typography>
        ),
      },
    },
    {
      name: "amount_left",
      label: "Amount Left (Rs)",
      options: {
        ...centeredColumnOptions,
        customBodyRender: (value, tableMeta) => (
          <Typography
            className="fs-12"
            sx={{ width: "100%", textAlign: "center", color: "error.main" }}
          >
            {formatAmountLeftTableDisplay(value, getLoanRowStatus(tableMeta))}
          </Typography>
        ),
      },
    },
    {
      name: "hr_status",
      label: "Status",
      options: {
        customBodyRender: (value) => (
          <Typography
            className={`${
              value === "approved"
                ? classes.present
                : value === "rejected"
                  ? classes.absent
                  : classes.halfDay
            }`}
            sx={{ fontSize: "10px", fontWeight: "600" }}
          >
            {value || "-"}
          </Typography>
        ),
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowId = tableMeta.rowData[0];
          return (
            <div className="leaves_management_btn_container">
              <button
                className="edit_btn"
                type="button"
                onClick={() => navigate(`/HR/loan-request/${rowId}`)}
              >
                <FaEye />
              </button>
              <button
                className="delete_btn"
                type="button"
                onClick={() => handleLoanDeleteClick(rowId)}
              >
                <BsTrashFill />
              </button>
            </div>
          );
        },
      },
    },
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    const filterSearch = filtered?.employees?.find((emp) => emp._id == id);
    if (id && filterSearch) {
      window.sessionStorage.setItem(
        "saveLoanUser",
        JSON.stringify(filterSearch),
      );
      setSearchName(filterSearch.full_name);
    }
    dispatch(getAllLoanRequests(page, size, id || ""));
  };

  const clearSearch = () => {
    setPageSearch(!pageSearch);
    window.sessionStorage.removeItem("saveLoanUser");
    setSearchName("");
    setId(undefined);
  };

  return (
    <div className="page_responsive">
      <DeleteConfirmModal
        show={show}
        onClose={() => setShow(false)}
        onConfirm={() => dispatch(indivisualLoanRequestDeleted(loanId))}
        loading={deleteLoading}
        message="Are u sure you want to delete this loan request?"
      />
      <Header title="Loan Requests" />
      <MetaData title="Loan Requests -- HRM" />
      <Container fluid>
        <Row className="m-0">
          <Col md={12}>
            <div className="employees_main_selection">
              <Form>
                <Row className="align-items-start justify-content-between">
                  <Col md={4}>
                    <Input>
                      <Form.Label>Employee Name</Form.Label>
                      <AutoCompleteSearch
                        data={filtered?.employees}
                        departmentData={id}
                        setDepartmentData={setId}
                        title="Search Employee"
                      />
                    </Input>
                    {searchName && (
                      <div
                        className="mx-2 rounded-2 p-2 mt-2"
                        style={{
                          fontSize: "12px",
                          fontStyle: "italic",
                          background: "#efefef",
                          width: "fit-content",
                        }}
                      >
                        <BiSearch />
                        <span className="mx-2">{searchName}</span>
                      </div>
                    )}
                  </Col>
                  <Col md={4}>
                    <div className="search_btn_container">
                      <button type="button" onClick={handleSearch}>
                        <FiSearch />
                        Search
                      </button>
                    </div>
                    <div className="search_btn_container mt-3">
                      <button type="button" onClick={clearSearch}>
                        <BiReset />
                        Clear Search
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
          <Col md={12}>
            {loading ? (
              <Loader />
            ) : (
              <div className="tickets_management_table">
                <MuiDataTable
                  title="ALL LOAN REQUESTS"
                  columns={columns}
                  data={loans || []}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={size}
                  setRowsPerPage={setSize}
                  count={loanCount}
                  tableId="hr_loan_requests_table"
                />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

function EmployeeRow({ value, navigate }) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Avatar src={value?.profile_picture?.[0]?.fileName} />
      <Typography
        onClick={() => value?.userId && navigate(`/HR/employee/${value.userId}`)}
        sx={{ pl: 1, cursor: value?.userId ? "pointer" : "default" }}
        className="fs-12 link__color"
      >
        {value?.full_name || "-"}
      </Typography>
    </div>
  );
}

export default LoanRequests;
